import {useEffect} from "react";
import {isMaternityForm} from "../Utils/KYCUtils";


const useSetMonthlyAvailableSavingsForRespContributions = (state) => {
    const kyc = state.knowYourClient;
    const subscriber = state.subscriber;
    const jointSubscriber = state.jointSubscriber;
    const setKyc = state.setKnowYourClient;

    useEffect(() => {

        let maternityForm = isMaternityForm(kyc);

        let monthlyDisposableIncomeTotal = (subscriber.monthlyIncomeNet + jointSubscriber.monthlyIncomeNet + kyc.otherMonthlyIncomeNet) - (kyc.paymentOnLoansAndDebts + kyc.morgageCondoFeesRent + kyc.groceries + kyc.childCare + kyc.clothing + kyc.insurance + kyc.utilities + kyc.transportation + kyc.miscellaneous);
        let monthlyDisposableIncomeTotalAfterMat = (subscriber.monthlyIncomeNet + jointSubscriber.monthlyIncomeNet + kyc.otherMonthlyIncomeNet) - (kyc.paymentOnLoansAndDebtsAfterMat + kyc.morgageCondoFeesRentAfterMat + kyc.groceries + kyc.childCare + kyc.clothing + kyc.insurance + kyc.utilities + kyc.transportation + kyc.miscellaneous);
        let monthlyIncomeGrossTotal = subscriber.monthlyIncomeGross + jointSubscriber.monthlyIncomeGross + kyc.otherMonthlyIncomeGross;
        let monthlyIncomeGrossTotalAfterMat = subscriber.monthlyIncomeGross + jointSubscriber.monthlyIncomeGross + kyc.otherMonthlyIncomeGross;

        let maxEspBasedOnDisposableIncome = (monthlyDisposableIncomeTotal - kyc.otherContractualObligations) * 0.6;

        let maxEspBasedOnDisposableIncomeAfterMat = (monthlyDisposableIncomeTotalAfterMat - kyc.otherContractualObligationsAfterMat) * 0.6;

        let maxEspBasedOnDisposableIncomeGroup = (monthlyDisposableIncomeTotal - kyc.otherContractualObligations) * 0.5;

        let maxEspBasedOnDisposableIncomeGroupAfterMat = (monthlyDisposableIncomeTotalAfterMat - kyc.otherContractualObligationsAfterMat) * 0.5;

        let maxEspBasedOnDsr = (monthlyIncomeGrossTotal * 0.5) - (kyc.paymentOnLoansAndDebts + kyc.morgageCondoFeesRent + kyc.otherContractualObligations);

        let maxEspBasedOnDsrGroup = (monthlyIncomeGrossTotal * 0.4) - (kyc.paymentOnLoansAndDebts + kyc.morgageCondoFeesRent + kyc.otherContractualObligations);

        let maxEspBasedOnDsrAfterMat = (monthlyIncomeGrossTotalAfterMat * 0.5) - (kyc.paymentOnLoansAndDebtsAfterMat + kyc.morgageCondoFeesRentAfterMat + kyc.otherContractualObligationsAfterMat);

        let maxEspBasedOnDsrGroupAfterMat = (monthlyIncomeGrossTotalAfterMat * 0.4) - (kyc.paymentOnLoansAndDebtsAfterMat + kyc.morgageCondoFeesRentAfterMat + kyc.otherContractualObligationsAfterMat);

        let monthlySavings;

        if (maternityForm) {
            let returnToWorkDate = new Date(kyc.returnToWorkDate);
            if (returnToWorkDate) {
                let dt1 = new Date();
                let dt2 = returnToWorkDate;
                let diffTime = Math.abs(dt2 - dt1);
                let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                let months = Math.ceil(diffDays / 30);
                let savings = kyc.availableSavingsForRespContributions;
                monthlySavings = Math.floor(savings / months);
            } else {
                monthlySavings = 0;
            }
        } else {
            monthlySavings = 0;
        }

        if (kyc.monthlyAvailableSavingsForRespContributions !== monthlySavings) { //TODO: Talk to Julian about this
            setKyc(prevState => ({
                ...prevState,
                monthlyAvailableSavingsForRespContributions: monthlySavings
            }));
        }

        maxEspBasedOnDisposableIncome += monthlySavings;
        maxEspBasedOnDisposableIncomeGroup += monthlySavings;
        maxEspBasedOnDsr += monthlySavings;
        maxEspBasedOnDsrGroup += monthlySavings;

        let lowest, lowestGroup;

        if (maternityForm) {
            lowest = Math.min(maxEspBasedOnDisposableIncomeAfterMat, maxEspBasedOnDsrAfterMat, maxEspBasedOnDisposableIncome, maxEspBasedOnDsr);
            lowestGroup = Math.min(maxEspBasedOnDisposableIncomeGroupAfterMat, maxEspBasedOnDsrGroupAfterMat, maxEspBasedOnDisposableIncomeGroup, maxEspBasedOnDsrGroup);
        } else {
            lowest = Math.min(maxEspBasedOnDisposableIncome, maxEspBasedOnDsr);
            lowestGroup = Math.min(maxEspBasedOnDisposableIncomeGroup, maxEspBasedOnDsrGroup);
        }

        let monthlyMaximumEducationSavingsPlan = lowest;
        let monthlyMaximumEducationSavingsPlanGroup = lowestGroup;
    }, [kyc, subscriber, jointSubscriber]);

}

export default useSetMonthlyAvailableSavingsForRespContributions;